export const mutations = {
  setServiceList (state, serviceList) {
    state.serviceList = serviceList
    state.isLoaded = true
  }
}
